module.exports = __webpack_public_path__ + "static/media/community_guideline_en_KH.69b91f2d.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/community_guideline_en_KH.md
// module id = 43
// module chunks = 0